import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const resolveImage = (url) =>
  url && url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Authed instance — injects Bearer token from localStorage
export const adminApi = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("trio_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("trio_admin_token");
      localStorage.removeItem("trio_admin_user");
      const path = window.location.pathname;
      const onStaff = path.startsWith("/staff");
      const loginTarget = onStaff ? "/staff/login" : "/admin/login";
      if (path !== loginTarget) {
        window.location.href = loginTarget;
      }
    }
    return Promise.reject(error);
  }
);

export const DOORDASH_URL =
  "https://www.doordash.com/store/trio-6241-university-dr-nw-huntsville-34121159/68219951/?event_type=autocomplete&pickup=false";

export const TRIO = {
  name: "Trio",
  tagline: "Eat. Drink. Vibe.",
  address: "6241 University Dr NW, Huntsville, AL",
  phone: "(256) 489-3274",
  hours: [
    { day: "Tue – Thu", time: "4pm – 11pm" },
    { day: "Fri – Sat", time: "4pm – 2am" },
    { day: "Sunday", time: "11am – 9pm (Brunch + Dinner)" },
    { day: "Monday", time: "Closed" },
  ],
};

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_trio-table/artifacts/6m7ve7di_D3EA0BB4-5B32-4927-9D24-98C45D3C71DA.png",
  brandWall:
    "https://customer-assets.emergentagent.com/job_trio-table/artifacts/c9xj9qkd_Resized__B2A6501_1702230778727.jpeg",
  interior:
    "https://customer-assets.emergentagent.com/job_trio-table/artifacts/dgp32ty0_IMG_4100.jpeg",
  loungeNeon:
    "https://customer-assets.emergentagent.com/job_trio-table/artifacts/1t43menl_Attachment%202.JPG",
  lambChops:
    "https://customer-assets.emergentagent.com/job_trio-table/artifacts/s5h8ka4e_IMG_8024.jpg",
  catfishPlate:
    "https://customer-assets.emergentagent.com/job_trio-table/artifacts/tqws9ify_IMG_2725.webp",
  linePlates:
    "https://customer-assets.emergentagent.com/job_trio-table/artifacts/ixzzd6tp_IMG_4953.webp",
};

export function getDeviceId() {
  let id = localStorage.getItem("trio_device_id");
  if (!id) {
    id =
      (crypto.randomUUID && crypto.randomUUID()) ||
      `dev-${Math.random().toString(36).slice(2)}-${Date.now()}`;
    localStorage.setItem("trio_device_id", id);
  }
  return id;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
